
        var result = require("!!../../../../node_modules/css-loader/index.js!./sponsor-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/sponsor-list/sponsor-list.component.css
// module id = 629
// module chunks = 0